import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { MButton } from "../../../../components/button";
import { RegularContainer } from "../../../../components/container";

const ChatroomPluginSection = () => {
    const { projectId, characterId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const path = `/projects/${projectId}/characters/${characterId}/bot-settings/web-widget`;

    return (
        <RegularContainer>
            <RegularContainer.Heading title={t("CHATROOM.PLUGIN_TITLE") || ""} />
            <RegularContainer.Content>
                <MButton btnText={t("CHATROOM.Plugin_BTN_SET")} handleClick={() => navigate(path)} />
            </RegularContainer.Content>
        </RegularContainer>
    );
};

export default ChatroomPluginSection;
